(function ($, Drupal) {

  // Main navigation JS
  Drupal.behaviors.initNav = {
    attach: function (context, settings) {

      $('.js_mainNavigation', context).once('initNav').each(function () {

        let $el = $(this),
          $menu =  $el.find('.mainmenu'),
          $triggermenu =  $el.find('.nav__trigger'),
          $navList = $el.find('.nav__wrapper'),
          $item = $navList.find('.nav__list-item'),
          $link = $item.find('.nav__link'),
          $subList = $navList.find('.nav__sublist-wrap'),
          $subListTrigger = $navList.find('.nav__sublist-wrap-trigger'),
          $langSwitch = $('.js_langSwitch'),
          $resPixel = $('.js_resolution'),
          $body = $('body'),
          $flag = false;

        function checkNavHeight() {
          if ($resPixel.css('opacity') == '1') {
            $item.removeClass('is_open');
            $subListTrigger.removeClass('is_open');
            $subListTrigger.siblings('.nav__sublist-wrap').removeClass('is_open');
          }
        }

        checkNavHeight();

        function clearActive() {
          $langSwitch.find('.langswitch__list').removeClass('is_open');
          $langSwitch.find('.langswitch__trigger').removeClass('is_active');
        }

        const trigger = throttle((e) => {
          checkNavHeight();
        }, 500);
        $(window).resize(trigger);

        $menu.on('touchstart click', function (evt) {

          evt.preventDefault();
          evt.stopPropagation();
          clearActive();

          if (!$flag) {
            $flag = true;
            setTimeout(function () {
              $flag = false;
            }, 100);
            $navList.toggleClass('is_open');

            if ($menu.hasClass('is-active')) {
              $menu.removeClass('is-active');
              $triggermenu.removeClass('is-active');
              $el.removeClass('is-active');
              $body.removeClass('noscroll');
            } else {
              $menu.addClass('is-active');
              $triggermenu.addClass('is-active');
              $el.addClass('is-active');
              $body.addClass('noscroll');
            }
          }
          return false;

        });

        $subListTrigger.on('click', function (evt) {

          evt.preventDefault();
          evt.stopPropagation();

          let $this = $(this),
            $wrap = $this.siblings('.nav__sublist-wrap'),
            $listItem = $this.closest('.nav__list-item');

          if (!$this.hasClass('is_open')) {
            $subListTrigger.removeClass('is_open');
            $subListTrigger.siblings('.nav__sublist-wrap').removeClass('is_open');
            $item.removeClass('is_open');
          }

          $this.hasClass('is_open') ? $this.removeClass('is_open') : $this.addClass('is_open');
          $wrap.hasClass('is_open') ? $wrap.removeClass('is_open') : $wrap.addClass('is_open');
          $listItem.hasClass('is_open') ? $listItem.removeClass('is_open') : $listItem.addClass('is_open');

        });

        $('.nav__overlay').click(() => {
          $navList.removeClass('is_open');
          $triggermenu.removeClass('is-active');
          $menu.removeClass('is-active');
          $triggermenu.removeClass('is-active');
          $el.removeClass('is-active');
          $body.removeClass('noscroll');
        });

        $(document).keyup(function(e) {
          if (e.keyCode === 27 && $menu.hasClass('is-active')) {
            $navList.removeClass('is_open');
            $triggermenu.removeClass('is-active');
            $menu.removeClass('is-active');
            $triggermenu.removeClass('is-active');
            $el.removeClass('is-active');
            $body.removeClass('noscroll');
          }
        });
      });
    }
  };

})(jQuery, Drupal);
